<div class="fh-page-wrapper">
  <header class="fh-header header bottom-border-divider">
    <app-backbuttontemplate />
    <h1 class="title">Username settings</h1>
  </header>

  <main class="fh-main content">
    <div class="formGroup" id="username-wrapper">
      <input
        data-testid="settings-username-input"
        type="text"
        class="formControl"
        placeholder="New username"
        maxlength="40"
        onkeydown="return /[abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_.0123456789]/g.test(event.key)"
        [(ngModel)]="usernameEntered"
      />
    </div>

    @if (showError) {
      <p class="error-hint">
        {{ error }}
      </p>
    }

    <button
      data-testid="settings-username-change-button"
      class="change-btn"
      [ngClass]="{
        'change-btn-disabled':
          buttonDisabled || !usernameEntered || showNotAllowed_TooRecent,
        'change-btn-enabled': !(buttonDisabled || !usernameEntered)
      }"
      [disabled]="buttonDisabled"
      (click)="changeUsername()"
    >
      Change username
    </button>

    @if (showNotAllowed_TooRecent) {
      <p class="error-hint">
        You cannot change your username because you have already changed it in
        the last 7 days.
      </p>
    }

    <hr class="inline-divider-thick" />

    <p id="username-info-below" class="username-desc remove-middle">
      Your current username:
      <br />
      <br />
      &#64;{{ currUsername$ | async }}
      <br />
      {{ currProfileURL$ | async }}
      <br />
      <br />
      Usernames may only contain letters, numbers, underscores, and periods.
      Changing your username will also change your profile link. You can change
      your username once every 7 days.
    </p>
  </main>
</div>
